const nullNotifier = {
  open: () => {},
  close: () => {},
  destroy: () => {},
}

/**
 * This should only be used in places where there is no react context, e.g. actions,
 * and just as default in case notifications isn't passed down.
 */
export const getNullApplicationNotifications = () => ({
  toast: nullNotifier,
  overlayBanner: nullNotifier,
  pageBanner: nullNotifier,
  snackbar: nullNotifier,
  debugger: nullNotifier,
})
